import React, { useState } from "react";
import { Container } from "./styles";
import { CiLogout } from "react-icons/ci";
import { GoSidebarCollapse, GoSidebarExpand } from "react-icons/go";
import { BiHome, BiListUl, BiPlus } from "react-icons/bi";
import { GrGroup } from "react-icons/gr";
import { useNavigate } from "react-router";

export default function Menu() {
	const [menuOpen, setMenuOpen] = useState(true);

	const navigate = useNavigate();

	const logout = () => {
		document.cookie = "isLoged=false; path=/;";
		document.cookie = "userId=''; path=/;";
		navigate("/login");
	};

	return (
		<>
			<Container className="menu">
				<div className={`menuOpen ${!menuOpen ? "close" : " "}`}>
					<ul>
						<div className="top">
							<button onClick={() => setMenuOpen(!menuOpen)}>
								{menuOpen ? <GoSidebarExpand /> : <GoSidebarCollapse />}{" "}
							</button>
						</div>

						<li>
							<a href="/">
								<BiHome /> Home
							</a>
						</li>
						<li>
							<a href="/addNotice">
								{" "}
								<BiPlus /> Adicionar notícia
							</a>
						</li>
						<li>
							<a href="/noticeManagement">
								<BiListUl /> Gerenciar notícias
							</a>
						</li>
						<li>
							<a href="/userManagement">
								<GrGroup /> Gerenciar permissões
							</a>
						</li>
					</ul>

					<div>
						<button onClick={() => logout()}>
							<CiLogout />
							<p>Sair</p>
						</button>
					</div>
				</div>
			</Container>
		</>
	);
}
